import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError, BaseResponse } from '@utils/types/shared/base';
import { PlanBo } from '@utils/types/back-office/update-plan-bo';

export type PlansListResponse = BaseResponse<PlanBo[]>;

/**
 * Hook to search plans with a query parameter.
 * Used for search inputs where we need backend filtering.
 */
export const useSearchPlansBo = (query?: string) => {
  const fetchPlans = async () => {
    let url = '/api/v3/admin/plan?offset=0&limit=50';
    if (query) {
      url += `&q=${encodeURIComponent(query)}`;
    }
    const { data } = await Axios.get<PlansListResponse>(url);
    return data;
  };

  return useQuery<PlansListResponse, AxiosError<BaseError>>(
    ['searchPlansBo', query],
    fetchPlans,
    {
      keepPreviousData: true,
      useErrorBoundary: false,
      staleTime: 30 * 1000 // 30 seconds
    }
  );
};
